import { AfterViewInit, ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@/layouts/header/header.component';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { LoaderComponent } from '@shared/components';
import { MaintenanceBannerComponent } from '../shared/components/maintenance-banner/maintenance-banner.component';
import { SidebarWrapperComponent } from '@/layouts/sidebar/sidebar-wrapper.component';
import { LayoutService } from '@/shared/services/ui';

@Component({
  selector: 'cis-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <cis-maintenance-banner />
    <cis-header />
    <cis-sidebar-wrapper />
    <div
      class="overflow-hidden"
      [class.transition-duration-300]="isLayoutInitialized()"
      [class.transition-all]="isLayoutInitialized()"
      [style.--sidebar-width]="sidebarVisible() ? '22rem' : '9rem'"
      [style.margin-left]="sidebarVisible() ? '18rem' : '5rem'">
      <div class="page-content">
        <cis-loader />
        <router-outlet />
      </div>
    </div>
  `,
  imports: [HeaderComponent, RouterOutlet, LoaderComponent, SidebarWrapperComponent, MaintenanceBannerComponent],
  providers: [BsDropdownDirective],
  styles: `
    .page-content {
      padding: 4rem 2rem 1rem;
      min-height: calc(100svh - 4rem);
    }
  `,
})

/**
 * Vertical component
 */
export class LayoutComponent implements OnInit, AfterViewInit {
  private readonly layoutService = inject(LayoutService);

  sidebarVisible = this.layoutService.sidebarVisible;
  isLayoutInitialized = signal(false);

  ngOnInit() {
    document.body.setAttribute('data-layout', 'vertical');
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.isLayoutInitialized.set(true);
    }, 100);
  }
}
